import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './modules/auth/services/auth.interceptor';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateLoader } from './shared/services/translations/multi-translate-loader';
import { TRANSLATION_FILES } from './shared/services/translations/translation-files.token';
import { provideTranslationInit } from './shared/services/translations/translation-init';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    { provide: TRANSLATION_FILES, useValue: ['common', 'nav', 'auth', 'dashboard', 'shared', 'products', 'reviews', 'settings', 'wallet', 'users_management', 'drivers_management', 'delivery_zones', 'orders', 'contact_us', 'notifications_center', 'superadmin/catalog', 'customer', 'superadmin/vendors', 'reports', 'superadmin/vendor_details', 'superadmin/vendor_profile', 'superadmin/vendor_products', 'superadmin/vendor_orders', 'superadmin/vendor_reviews', 'superadmin/vendor_wallet', 'superadmin/vendor_team', 'superadmin/users', 'superadmin/user_details', 'superadmin/inquiries'] },
    provideTranslateService({
      defaultLanguage: 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient, files: string[]) => new MultiTranslateLoader(http, files),
        deps: [HttpClient, TRANSLATION_FILES],
      },
    }),
    provideTranslationInit(),
  ],
};
